import { checkPhoneNumber, validateEmail } from '@/shared/lib';
import _ from 'lodash';
import { t } from 'ttag';

/**
 * Validates the marketing Learn More contact form before a consulting request is sent. Requires a trimmed name, facility name and phone number, wording those messages differently for the other-modal variant, and rejects a phone number failing checkPhoneNumber or a contact email failing validateEmail.
 *
 * @param data - The form values to validate.
 * @param isOtherModal - Whether the other-modal wording is used in the required-field messages.
 * @returns The field names mapped to their validation messages, empty when the form is valid.
 */
export const handleValidateData = (data: any, isOtherModal?: any) => {
  const errorObject = {};
  const nameTrim = data?.name?.trim();
  if (!nameTrim) {
    // _.assign(errorObject, { name: t`${isOtherModal ? 'Name' : 'Your name'} is required.` });
    _.assign(errorObject, { name: `${isOtherModal ? 'Name' : 'Your name'} is required.` });
  }

  const facilityNameTrim = data?.facilityName?.trim();
  if (!facilityNameTrim) {
    // _.assign(errorObject, { facilityName: t`${isOtherModal ? 'Facility name' : 'Your facility name'} is required.` });
    _.assign(errorObject, {
      facilityName: `${isOtherModal ? 'Facility name' : 'Your facility name'} is required.`,
    });
  }

  const phoneNumberTrim = data?.phoneNumber?.trim();
  if (phoneNumberTrim) {
    if (!checkPhoneNumber(phoneNumberTrim)) {
      _.assign(errorObject, {
        phoneNumber: t`The field contains phone number with invalid format, please check again!`,
      });
    }
  } else {
    // _.assign(errorObject, { phoneNumber: t`${isOtherModal ? 'Phone number' : 'Your phone number'} is required.` });
    _.assign(errorObject, {
      phoneNumber: `${isOtherModal ? 'Phone number' : 'Your phone number'} is required.`,
    });
  }

  //* validate emails
  const contactEmailTrim = data?.contactEmail?.trim();

  if (contactEmailTrim) {
    if (!validateEmail(contactEmailTrim)) {
      _.assign(errorObject, {
        contactEmail: t`The field contains email with invalid format, please check again!`,
      });
    }
  }

  return errorObject;
};

export const ERROR_IP_SPAM = t`We're sorry, but we are unable to fulfill your consultation request at the moment!`;
